import { Box, Button, Grid, Typography } from "@mui/material";
import { baseWebUrl } from "lib/constants";
import { BusinessList } from "lib/features/businessList/types";
import { useNavigate, useParams } from "react-router-dom";
import { myBusinessListStyles } from "styles/BusinessListDirectory/myBusinessList.styles";
import QRCodeContainer from "../QRCodeContainer";
import BusinessActionCard from "./BusinessActionCard";
import ShareContainer from "./ShareContainer";

interface SelectedBusinessListViewProps {
  selectedBusiness: BusinessList;
}

const SelectedBusinessListView = ({
  selectedBusiness,
}: SelectedBusinessListViewProps) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const link = selectedBusiness
    ? `${baseWebUrl}/business/checkout/${selectedBusiness?.id}`
    : `No list assosiated`;

  return (
    <Box>
      {/* QR Details */}
      <Box sx={myBusinessListStyles.qrDetailsContainer}>
        {/* QR Container */}
        <Box sx={myBusinessListStyles.qrContainer}>
          <QRCodeContainer link={link} />
        </Box>

        {/* QR Details */}
        <Box sx={myBusinessListStyles.qrDetails}>
          <Typography sx={myBusinessListStyles.mainHeading}>
            {selectedBusiness.list_name}
          </Typography>
          <Typography sx={myBusinessListStyles.subHeading}>
            {selectedBusiness.list_headline}
          </Typography>
          <Button
            variant="outlined"
            sx={myBusinessListStyles.editButton}
            onClick={() =>
              navigate(
                `/businesslist/create/${id}?list=${selectedBusiness?.id}`
              )
            }
          >
            Edit Business List
          </Button>
          {/* Share business list */}
          <ShareContainer link={link} />
        </Box>
      </Box>

      {/* Businesses */}

      <Box marginY={5}>
        <Typography sx={myBusinessListStyles.inputLabel}>Businesses</Typography>

        <Grid
          container
          spacing={2}
          marginTop={1}
          sx={{
            flexWrap: "wrap",
          }}
        >
          {selectedBusiness?.businesses?.length > 0 &&
            selectedBusiness?.businesses.map((business) => (
              <Grid item xs={12} sm={6} md={4} lg={4} key={business.id}>
                <BusinessActionCard business={business} isDeletable={false} />
              </Grid>
            ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default SelectedBusinessListView;
